import { render, staticRenderFns } from "./MicrobialTestingofLafu.vue?vue&type=template&id=40965b62&scoped=true&"
import script from "./MicrobialTestingofLafu.vue?vue&type=script&lang=js&"
export * from "./MicrobialTestingofLafu.vue?vue&type=script&lang=js&"
import style0 from "./MicrobialTestingofLafu.vue?vue&type=style&index=0&id=40965b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40965b62",
  null
  
)

export default component.exports